import { createEnv } from "@t3-oss/env-nextjs";
import { getEnvOptions } from "@watt/common/config/env-options";
import { ZodError } from "zod";

function getEnv() {
  try {
    return createEnv(getEnvOptions());
  } catch (error) {
    if (error instanceof ZodError) {
      // Use Zod's formatting methods to see all issues
      console.error("Environment variable errors:", error.flatten());
    }

    // Re-throw so tests/builds still fail
    throw error;
  }
}

export const env = getEnv();
